import * as React from "react";

const ShoppingCart: React.FC = () => {
    return (
        <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="presentation"
        >
            <path
                d="M9.72723 24.455C10.3298 24.455 10.8182 23.9665 10.8182 23.364C10.8182 22.7614 10.3298 22.273 9.72723 22.273C9.12469 22.273 8.63623 22.7614 8.63623 23.364C8.63623 23.9665 9.12469 24.455 9.72723 24.455Z"
                stroke="#545454"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M21.7272 24.455C22.3298 24.455 22.8182 23.9665 22.8182 23.364C22.8182 22.7614 22.3298 22.273 21.7272 22.273C21.1247 22.273 20.6362 22.7614 20.6362 23.364C20.6362 23.9665 21.1247 24.455 21.7272 24.455Z"
                stroke="#545454"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M1 1.54599H5.364L8.287 16.155C8.38667 16.6574 8.65988 17.1087 9.0588 17.4299C9.45772 17.7511 9.95692 17.9218 10.469 17.912H21.069C21.5816 17.9227 22.0817 17.7524 22.4812 17.4311C22.8808 17.1098 23.1544 16.658 23.254 16.155L25 7.00199H6.454"
                stroke="#545454"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};

export default React.memo(ShoppingCart);
